<template>
  <van-col style="width: 100%; background-color: #f7f7f7;">
    <div class="client-title">
      <div class="client-line"></div>
      <div class="client-text">我的客户</div>
    </div>

    <van-search v-model="listQuery.nameLike" shape="round" @search="onSearch" placeholder="请输入客户名/联系人/电话"
      style="margin-top: 20px;" />

    <van-dropdown-menu v-if="duty == 3 || duty == 99">
      <van-dropdown-item title="业务员" v-model="listQuery.salesmanId" v-if="duty == 99" :options="listUserBoss"
        @change="onSelectItem" />
      <van-dropdown-item title="业务员" ref="item" v-if="duty == 3">
        <van-row>
          <van-col span="12">
            <van-list :finished="true" :immediate-check=false>
              <div v-for="(item, index) in listBoss" :key="index" @click="onClickBossItem(item)"
                :style="getTextStyle(item)">{{ item.enterpriseName }}</div>
            </van-list>
          </van-col>
          <van-col span="12">
            <van-list :finished="true" :immediate-check=false>
              <div v-for="(item, index) in listUserBoss" :key="index" @click="onClickItem(item)"
                :style="getTextUserStyle(item)">{{ item.text }}</div>
            </van-list>
          </van-col>
        </van-row>
      </van-dropdown-item>
      <van-dropdown-item title="到期日期" v-model="listQuery.day" :options="dateOption" @change="onSelectItem" />
    </van-dropdown-menu>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check=false>
        <van-cell-group v-for="(item, index) in list" :key="index" style="margin-top: 12px;">
          <van-cell title="客户名称" :value="item.name" :border="false" />
          <van-cell title="公司" :value="item.enterpriseName" :border="false" />
          <van-cell title="电话" :value="item.phone" :border="false" />
          <van-cell title="对接团队" :value="item.firmStr" :border="false" />
          <van-cell title="团负责人" :value="item.firmUserStr" :border="false" />
          <van-cell title="对接业务员" :value="item.salesmanStr" :border="false" />
          <van-field v-model="item.bankName" label="借款银行" placeholder="请输入借款银行" input-align="right" right-icon="edit"
            @input="onChangeText(item)" :border="false" />
          <van-field v-model="item.money" label="借款金额" placeholder="请输入借款金额" type="number" input-align="right"
            right-icon="edit" @input="onChangeText(item)" :border="false" />
          <van-cell title="到期时间" is-link @click="onClickDate(item)" :border="false">
            <template #default>
              <van-row type="flex" justify="end" v-if="item.loansExpireTime">
                <van-col span="20">{{ item.loansExpireTime }}</van-col>
                <div>剩余</div>
                <div style="color:#3a71ffff; fontSize:25px; fontWeight: bold; ">{{ daysDifference(item.loansExpireTime) }}
                </div>
                <div>天</div>
              </van-row>
              <div class="client-tags" v-if="!item.loansExpireTime">
                <div>请选择到期时间</div>
              </div>
            </template>
          </van-cell>
        </van-cell-group>

      </van-list>
    </van-pull-refresh>

    <van-popup v-model="showSelectDate" round position="bottom">
      <van-datetime-picker v-model="currentDate" type="datetime" title="选择时间" :min-date="minDate" :max-date="maxDate"
        @confirm="onConfirmDate" @cancel="onCancelDate" />
    </van-popup>

  </van-col>
</template>

<script>

import request from "@/utils/request";
import user from '@/utils/user'
import moment from 'moment';

export default {
  props: {
    nameLike: {
      type: String,
      default: ""
    },
    salesmanId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      duty: -1,
      firmId: "",
      dateOption: [
        { text: '全部', value: null },
        { text: '<60天', value: '60' },
        { text: '<45天', value: '45' },
        { text: '<30天', value: '30' },
        { text: '<15天', value: '15' },
        { text: '<7天', value: '7' },
      ],
      list: [],
      selectItem: {},
      loading: false,
      finished: false,
      refreshing: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 0, 1),
      currentDate: new Date(),
      showSelectDate: false,
      listBoss: [],
      listUserBoss: [],
      listQuery: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        nameLike: "",
        day: null,
        salesmanId: "",
      },
    };
  },
  created() {
    this.duty = user.getUserDuty()
    this.firmId = user.getUserFirmId()

    this.listQuery.nameLike = this.nameLike
    this.listQuery.salesmanId = this.salesmanId

    if (this.duty < 3) {
      //企业员工
      this.onLoad()
    } else if (this.duty == 3 || this.duty == 4) {
      //企业老板
      this.onLoadBoss()
      this.onLoad()
    } else if (this.duty == 99) {
      //企业负责人
      this.onLoadBossUser(this.firmId)
      this.onLoad()
    } else {
      this.$router.replace({ name: 'noPermission' });
    }
  },
  methods: {
    daysDifference(time) {
      const startDate = moment(new Date(), 'YYYY-MM-DD hh:mm'); // 使用正确的格式字符串，例如'YYYY-MM-DD'或'DD/MM/YYYY'等，取决于输入格式。
      const endDate = moment(time, 'YYYY-MM-DD hh:mm'); // 同上。
      return startDate.isValid() && endDate.isValid() ? endDate.diff(startDate, 'days') : 0;
    },
    onSearch() {
      this.onRefresh()
    },
    onSelectItem() {
      this.onRefresh()
    },
    getTextStyle(item) {
      if (item.clientCount == -1) {
        return {
          padding: '12px',
          color: '#3A71FFFF',
          backgroundColor: '#3A71FF1A',
        };
      } else {
        return {
          padding: '12px',
          color: '#666666',
          backgroundColor: '#ffffff',
        };
      }
    },
    getTextUserStyle(item) {
      if (item.isDeleted == -1) {
        return {
          padding: '12px',
          color: '#3A71FFFF',
          backgroundColor: '#3A71FF1A',
        };
      } else {
        return {
          padding: '12px',
          color: '#666666',
          backgroundColor: '#ffffff',
        };
      }
    },
    onClickBossItem(item) {
      this.listBoss.forEach(action => {
        action.clientCount = -2
      });
      item.clientCount = -1
      this.onLoadBossUser(item.id)
    },
    onClickItem(item) {
      this.listUserBoss.forEach(action => {
        action.isDeleted = -2
      });
      item.isDeleted = -1
      this.$refs.item.toggle();

      this.listQuery.salesmanId = item.id
      this.onRefresh()
    },
    onChangeText(item) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        var filterFomr = Object.assign({}, item);
        request.post("/User/ClientInfo/Update", filterFomr).then(() => {

        }).catch(() => {
        });
      }, 500);
    },
    onLoadBoss() {
      request.post("/User/MyTeam/AdminClient", {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        firmId: this.firmId,
      }).then((res) => {
        this.listBoss = res.data.data.data;
      }).catch(() => {
      });
    },
    onLoadBossUser(id) {
      request.get("/User/Department/GetStaffList", { params: { firmId: id } })
        .then((res) => {
          res.data.data.forEach(action => {
            this.listUserBoss.push({ text: action.name, value: action.id, isDeleted: -2 });
          });
        }).catch(() => {
        });
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.listQuery.page = 1;
      }

      var url = ""
      if (this.duty < 3) {
        url = "/User/ClientInfo/MyClient"
      } else if (this.duty == 3) {
        url = "/User/ClientInfo/CorporationClient"
      } else if (this.duty == 99) {
        url = "/User/ClientInfo/AdminClient"
      }
      if (!url) {
        return
      }
      var filterFomr = Object.assign({}, this.listQuery);
      request.post(url, filterFomr).then((res) => {
        this.listQuery.page = res.data.data.pageInfo.page + 1;
        this.list = res.data.data.data;
        this.finished = !res.data.data.pageInfo.hasMore;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    onClickDate(item) {
      this.selectItem = item
      this.showSelectDate = true;
    },
    onConfirmDate(value) {
      this.showSelectDate = false;
      this.selectItem.loansExpireTime = value.toLocaleString();

      this.onChangeText(this.selectItem)
    },
    onCancelDate() {
      this.showSelectDate = false;
    },

  }
};
</script>

<style lang="less">
.client-title {
  display: flex;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.client-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.client-text {
  color: #333;
  margin-left: 6px;
}

.client-tags {
  background-color: #3a71ffff;
  display: flex;
  justify-content: right;
  align-items: center;
}

.client-content {
  padding-right: 20px;
  text-align: right;
  color: #333;
  border: none;
  width: 95%;
}
</style>
